module.exports = __webpack_public_path__ + "img/choose.0069fe34.png";